import { Box, Button, Typography, Stack, useTheme } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  ActivityTypeEnum,
  EntityTypeEnum,
} from "./enums/workOrderActivity.enums";
import { useState } from "react";
import { ActivityItemProps } from "./types/workOrderActivityTypes";
import AttachmentActivityView from "./AttachmentActivityView";
import { entityLabelMap } from "./records/activityPropsRecordsUtility";
import { getActivityAction } from "./activityUtility";

const ActivityItem = ({
  color,
  user,
  action,
  target,
  entity,
  setCurrentTabIndex,
  isCollapsed = false,
  onToggleCollapse,
}: ActivityItemProps) => {
  //("entity", entity);
  const theme = useTheme();

  const [showDialog, setShowDialog] = useState(false);
  const handleViewDetail = () => {
    setCurrentTabIndex(1); // or whatever tab index you want to switch to
  };

  const renderEntityContent = () => {
    switch (entity.relatedEntity) {
      case EntityTypeEnum.SegAttachment:
      case EntityTypeEnum.SegAttachmentImage:
        return (
          <Stack spacing={1} direction="column">
            <AttachmentActivityView
              target={String(
                entityLabelMap[entity.relatedEntity]?.(entity) ||
                  "Unknown Entity"
              )}
              color={
                entity.activityType === ActivityTypeEnum.INSERT
                  ? "green"
                  : entity.activityType === ActivityTypeEnum.UPDATE
                  ? "blue"
                  : "red"
              }
              user={entity.changedBy}
              action={getActivityAction(entity)}
              entity={entity}
              setCurrentTabIndex={setCurrentTabIndex}
            />
            {!isCollapsed && (
              <Button
                variant="outlined"
                size="small"
                sx={{
                  alignSelf: "start",
                  textTransform: "none",
                  borderRadius: 2,
                  fontWeight: 500,
                }}
                onClick={handleViewDetail}
              >
                View Attachment
              </Button>
            )}
          </Stack>
        );

      case EntityTypeEnum.SegItems:
        return (
          <Stack spacing={1} direction="column">
            <Typography variant="body2">
              <strong>{user}</strong> {action} <strong>{target}</strong> on{" "}
              <strong>{entity.segmentName}</strong>
            </Typography>
          </Stack>
        );

      case EntityTypeEnum.SegLabor:
        return (
          <Stack spacing={1} direction="column">
            <Typography variant="body2">
              <strong>{user}</strong> {action} {target}
            </Typography>
          </Stack>
        );

      default:
        return (
          <Typography variant="body2">
            <strong>{user}</strong> {action} {target}
          </Typography>
        );
    }
  };

  // Render collapsed version (summary only)
  if (isCollapsed) {
    return (
      <Box
        display="flex"
        alignItems="flex-start"
        gap={1}
        mb={1}
        sx={{
          backgroundColor: theme.palette.mode === "light" ? "#fff" : "#181F2A",
          borderRadius: 1,
          p: 1,
        }}
      >
        <FiberManualRecordIcon sx={{ fontSize: 12, color, mt: "4px" }} />
        <Typography
          variant="body2"
          sx={{ fontStyle: "italic", color: "text.secondary" }}
        >
          <strong>{user}</strong> {action} {target}
          {entity.relatedEntity === EntityTypeEnum.SegItems && (
            <>
              {" on "}
              <strong>{entity.segmentName}</strong>
            </>
          )}
        </Typography>
      </Box>
    );
  }

  // Render full version
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap={1}
      mb={1}
      sx={{
        backgroundColor: theme.palette.mode === "light" ? "#fff" : "#181F2A",
        borderRadius: 1,
        p: 1,
      }}
    >
      <FiberManualRecordIcon sx={{ fontSize: 12, color, mt: "4px" }} />
      {renderEntityContent()}
    </Box>
  );
};

export default ActivityItem;
